import { businessService } from '@/pages/Business/services/business.service';
import type { PickUpChildShippingsResponse } from '../models';

const pickupTransitionsApi = businessService.injectEndpoints({
  endpoints: (builder) => ({
    getPickupChildShippings: builder.query<
      PickUpChildShippingsResponse,
      { shippingNumber: number | string; page: number; pageSize: number }
    >({
      query: ({ shippingNumber, page, pageSize }) => ({
        url: `/shipping/picked-up/${shippingNumber}`,
        params: {
          limit: pageSize,
          offset: (page - 1) * pageSize,
        },
      }),
      providesTags: ['PickupTransitions'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetPickupChildShippingsQuery } = pickupTransitionsApi;
